import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateSimXUserRequest } from '../models/requests/create-simx-user-request.model';
import { GetSimXUserRequest } from '../models/requests/get-simx-user-request.model';
import { GetSimXUsersRequest } from '../models/requests/get-simx-users-request.model';
import { ResetSimXUserPasswordRequest } from '../models/requests/reset-simx-user-password-request.model';
import { UpdateSimXUserPasswordRequest } from '../models/requests/update-simx-user-password-request.model';
import { UpdateSimXUserRequest } from '../models/requests/update-simx-user-request.model';
import { CreateSimXUserResponse } from '../models/responses/create-simx-user-response.model';
import { GetSimXUserResponse } from '../models/responses/get-simx-user-response.model';
import { GetSimXUsersResponse } from '../models/responses/get-simx-users-response.model';
import { ResetSimXUserPasswordResponse } from '../models/responses/reset-simx-user-password-response.model';
import { UpdateSimXUserPasswordResponse } from '../models/responses/update-simx-user-password-response.model';
import { UpdateSimXUserResponse } from '../models/responses/update-simx-user-response.model';
import { DataService } from './data.service';

@Injectable({ providedIn: 'root' })
export class UserDataService {
  private readonly _dataService = inject(DataService);
  private readonly _http = inject(HttpClient);

  getUsers(
    request: GetSimXUsersRequest = {},
  ): Observable<GetSimXUsersResponse> {
    const url = this._dataService.usersUrl();
    return this._http.post<GetSimXUsersResponse>(url, request);
  }

  getUser(
    userId: string,
    request: GetSimXUserRequest = {},
  ): Observable<GetSimXUserResponse> {
    const url = this._dataService.usersUrl(userId);
    return this._http.post<GetSimXUserResponse>(url, request);
  }

  createUser(
    request: CreateSimXUserRequest,
  ): Observable<CreateSimXUserResponse> {
    const url = this._dataService.usersUrl();
    return this._http.put<CreateSimXUserResponse>(url, request);
  }

  updateUser(
    userId: string,
    request: UpdateSimXUserRequest,
  ): Observable<UpdateSimXUserResponse> {
    const url = this._dataService.usersUrl(userId);
    return this._http.patch<UpdateSimXUserResponse>(url, request);
  }

  updateUserPassword(
    userId: string,
    request: UpdateSimXUserPasswordRequest,
  ): Observable<UpdateSimXUserPasswordResponse> {
    const url = this._dataService.updateUserPasswordUrl(userId);
    return this._http.patch<UpdateSimXUserPasswordResponse>(url, request);
  }

  resetUserPassword(
    request: ResetSimXUserPasswordRequest,
  ): Observable<ResetSimXUserPasswordResponse> {
    const url = this._dataService.resetUserPasswordUrl();
    return this._http.post<ResetSimXUserPasswordResponse>(url, request);
  }
}
